import { FiltersSelection } from "frontend/icons/orgchart-filters-selection";
import { DropdownButton } from "../../toolbar-buttons";
import checkboxStyle from "./mindmap-org-chart-fields-picker.module.css";
import { LiveIntegrationFiltersPicker } from "frontend/canvas-designer-new/elements-toolbar-cim-restyle/widgets/live-integration/liveIntegrationFiltersPicker";
import { fromPairs, map, pipe, toPairs } from "rambda";
import { LiveIntegrationFilter } from "frontend/canvas-designer-new/elements-toolbar/widgets/live-integration/utils";
import cn from "classnames";
import { useBoardTasks } from "frontend/hooks/use-board-integrations";

const transformToObject = (input: any) => {
  return pipe(
    // @ts-expect-error any type is making ts go nuts.
    map(({ columnId, columnValues }) => [columnId, columnValues]),
    fromPairs
  )(input);
};

const transformToArray = (input: any) => {
  return pipe(
    toPairs,
    map(([columnId, columnValues]) => ({ columnId, columnValues }))
  )(input);
};

export default function MindmapOrgChartFilterPicker({
  value,
  onChange,
  tooltip,
  documentId,
}: {
  value: {
    items: { [key: string]: string[] };
    selected: { [column: string]: string[] };
    titles: { [column: string]: string };
    integrationId?: string;
  };
  onChange: (value: any) => void;
  tooltip?: string;
  documentId?: string;
}) {
  const clearAll = () => {
    onChange({});
  };
  const { getBoardIntegrationConfig } = useBoardTasks(documentId);
  const columns = getBoardIntegrationConfig(value.integrationId || "")?.columns ?? [];

  function renderFiltersPopup() {
    return (
      <>
        <div className={checkboxStyle.checkboxDropdownContainer} style={{ whiteSpace: "nowrap" }}>
          <div className={checkboxStyle.title}>
            <span>Filter</span>

            <span
              className={cn(checkboxStyle.clearAll, {
                [checkboxStyle.clearAllActive]: Object.keys(value.selected ?? {}).length > 0,
              })}
              onClick={clearAll}
            >
              Clear All
            </span>
          </div>

          <LiveIntegrationFiltersPicker
            columns={columns}
            filters={transformToArray(value.selected ?? {}) as LiveIntegrationFilter[]}
            onSelectFilters={(filters) => {
              onChange(transformToObject(filters ?? []));
            }}
            readonly={false}
          />
        </div>
      </>
    );
  }

  return (
    <DropdownButton
      tooltip={tooltip ?? "Change filter"}
      renderPopup={() => renderFiltersPopup}
      className={checkboxStyle.arrowBackground}
      arrowSize={0}
    >
      <FiltersSelection size={20} />
    </DropdownButton>
  );
}
